import { createApi } from '@reduxjs/toolkit/query/react';
import { ReferentPriceType } from '@strata/constants';

import { RATE_SETTER_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export interface DefaultRate {
    payerId: string;
    defaultRate: number;
    referentPriceType: ReferentPriceType;
    isFrozen: boolean;
}

export const rateSetterApi = createApi({
    baseQuery: getBaseQuery(RATE_SETTER_API_URL, true),
    reducerPath: 'rateSetterApi',
    endpoints: (build) => ({
        getDefaultRatesForProduct: build.query<
            DefaultRate[],
            {
                payerId?: string;
                isBrand: boolean;
                productServiceOid: string;
                placeOfService?: string;
            }
        >({
            query: ({ payerId, productServiceOid, placeOfService, isBrand }) => ({
                url: 'rate_rules',
                params: {
                    place_of_service: placeOfService,
                    is_brand: isBrand,
                    payer_id: payerId,
                    product_service_oid: productServiceOid,
                },
            }),
            transformResponse: (
                response: {
                    payer_id: string;
                    default_rate: string;
                    referent_price_type: ReferentPriceType;
                    is_frozen: boolean;
                }[],
            ) =>
                (response ?? [])
                    .map((rateRule) => ({
                        payerId: rateRule.payer_id,
                        defaultRate: Number(rateRule.default_rate),
                        referentPriceType: rateRule.referent_price_type,
                        isFrozen: rateRule.is_frozen,
                    }))
                    // Sort highest rates first
                    .sort((a, b) => b.defaultRate - a.defaultRate),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving default rates for product.',
            ),
        }),
    }),
});

export const { useGetDefaultRatesForProductQuery } = rateSetterApi;
